import React from "react";
import Collapsible from "react-collapsible";
import { Rating } from "@mui/material";
import clsx from "clsx";
import { getMaterialIcon } from "#utils/icons";
import pluralize from "pluralize";
const StarRoundedIcon = getMaterialIcon("StarRounded");

const StarRating = ({ text, value, isTrigger }) => {
  // NOTE: this is obnoxious because of the chevron trigger in the Collapsible component below -
  // flex positioning messes up the chevron positioning (but only on actual mobile devices)
  return (
    <span
      className={clsx(
        "mb-1",
        isTrigger ? "text-base md:text-lg" : "text-sm md:text-base",
        !isTrigger && "flex flex-row gap-2 items-center"
      )}
    >
      {text && <span className="w-[90px] md:w-[120px]">{`${text}: `}</span>}
      <Rating
        name={`${text}-rating`}
        precision={0.1}
        size={isTrigger ? "medium" : "small"}
        readOnly
        icon={<StarRoundedIcon className="stroke-offBlack text-yellow" fontSize="inherit" />}
        emptyIcon={<StarRoundedIcon className="stroke-offBlack text-white" fontSize="inherit" />}
        value={Number(value ?? 0)}
      />
      <span className={clsx("mx-2", isTrigger && "relative -top-[5px]")}>{value}</span>
    </span>
  );
};

const BookDetails = ({ book }) => {
  const ratings = book?.aggregate_ratings;
  const chevron = "relative after:transform after:transition-all after:font-sans after:content-['›'] after:absolute";

  return (
    <>
      <h1 className="text-[20px] md:text-[36px] leading-tight">{book?.title}</h1>
      <a href={`/authors/${book?.author_uuid}`} className="w-fit block">
        <h3 className="leading-tight">{book?.author_name}</h3>
      </a>

      <div className="flex flex-col gap-1 my-2 md:gap-2 md:my-4">
        <div className="font-space font-bold">
          <Collapsible
            trigger={<StarRating value={ratings?.overall || "0.0"} isTrigger />}
            triggerClassName={`${chevron} ${!ratings?.overall && "hidden"} after:rotate-90`}
            triggerOpenedClassName={`${chevron} after:-rotate-90`}
            transitionTime={200}
            triggerElementProps={{ id: `collapsible-trigger-${book.uuid}` }}
            contentElementId={`collapsible-content-${book.uuid}`}
            className="relative z-0"
          >
            <StarRating text="Enjoyment" value={ratings?.entertainment} />
            <StarRating text="Quality" value={ratings?.quality} />
            <StarRating text="Characters" value={ratings?.character} />
            <StarRating text="Plot" value={ratings?.plot} />
          </Collapsible>
        </div>
        {ratings && ratings.emojis.length > 0 && (
          <div className="flex flex-row gap-2 justify-start leading-none">
            {ratings.emojis.map((e, i) => (
              <div key={`emoji_${i}`} className="text-[25px]">
                {e}
              </div>
            ))}
          </div>
        )}
        <div className="text-[12px] md:text-[14px] font-bold text-[#004ABE] leading-tight">
          <a href={`/books/${book.uuid}?view=reviews`}>{pluralize("rating", ratings?.ratings_count || 0, true)}</a> •{" "}
          <a href={`/books/${book.uuid}?view=forum`}>{pluralize("post", book?.post_count || 0, true)}</a>
        </div>
      </div>
    </>
  );
};

export default BookDetails;
